module.exports = __webpack_public_path__ + "img/qrcode.6b65cb3c.jpg";